import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title, 
  description, 
  keywords,
  ogTitle,
  ogDescription 
}) => {
  const defaultTitle = "Trademark Brand Logo - Professional Trademark Registration & IP Services";
  const defaultDescription = "Professional trademark registration and intellectual property services. Expert USPTO filing, comprehensive trademark search, copyright registration, and brand protection. 98% success rate, 15,000+ trademarks filed.";
  const defaultKeywords = "trademark registration, USPTO filing, trademark search, copyright registration, intellectual property, brand protection, trademark attorney, company formation, Amazon brand registry";

  return (
    <Helmet>
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta property="og:title" content={ogTitle || title || defaultTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title || defaultTitle} />
      <meta name="twitter:description" content={ogDescription || description || defaultDescription} />
    </Helmet>
  );
};

export default SEO;
